/* eslint-disable prefer-promise-reject-errors */
import React, {
  createContext,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import authservice from "../services/auth.services";

export const StoreContext = createContext();

const sidebarIcons = [
  {
    id: 1,
    url: "/images/grocery.svg",
  },
  {
    id: 2,
    url: "/images/dairy.svg",
  },
  {
    id: 3,
    url: "/images/fruits&veg.svg",
  },
  {
    id: 4,
    url: "/images/health.svg",
  },
  {
    id: 5,
    url: "/images/other-store.svg",
  },
  {
    id: 6,
    url: "/images/confectionary.svg",
  },
  {
    id: 7,
    url: "/images/canteen.svg",
  },
  {
    id: 8,
    url: "/images/apparel-store.svg",
  },
  {
    id: 9,
    url: "/images/hardware-store.svg",
  },
  {
    id: 10,
    url: "/images/it-computer-electronics.svg",
  },
  {
    id: 11,
    url: "/images/cafe.svg",
  },
  {
    id: 11,
    url: "/images/Group.svg",
  },
];

const ApiContext = ({ children }) => {
  const lat = parseFloat(localStorage.getItem("selectedCityLat"));
  const lng = parseFloat(localStorage.getItem("selectedCityLng"));
  const scrollToMapSectionRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [location, setLocation] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedStoreID, setSelectedStoreID] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [recenterCurLoc, setRecenterCurLoc] = useState(false);
  const [manuallyToggled, setManuallyToggled] = useState(false);
  const [currentLocLoader, setCurrentLocLoader] = useState(false);
  const [storesLatLng, setStoresLatLng] = useState({});
  const [stores, setStores] = useState([]);
  const [storeTypes, setStoreTypes] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [nearbyStores, setNearByStores] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [showSelect, setShowSelect] = useState(window.innerWidth > 805);
  const [cityLatLng, setCityLatLng] = useState({ lat: null, lng: null });
  const [totalRecords, setTotalRecords] = useState();
  const [loadmoreIsClicked, setLoadmoreIsClicked] = useState(false);
  const [selectedStore, setSelectedStore] = useState({
    name: "All Stores",
    storeTypeID: "",
  });
  const [selectedSortOption, setSelectedSortOption] = useState({
    label: "Select Stores",
    value: "",
  });

  /* Function To Get Curent Location from Geo Location ------------------------------- */
  const fetchCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject("Geolocation is not supported");
        return;
      }
      setCurrentLocLoader(true);
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`,
            );
            const data = await response.json();
            const city =
              data?.address?.city ||
              data?.address?.town ||
              data?.address?.village ||
              data?.address?.state;
            const region =
              data?.address?.suburb ||
              data?.address?.neighbourhood ||
              data?.address?.residential ||
              data?.address?.road ||
              "";
            const state = data?.address?.state || "";
            const country = data?.address?.country || "";
            const countryCode =
              data?.address?.country_code?.toUpperCase() || "";
            const zip = data?.address?.postcode || "";
            const currentLocationData = {
              city,
              region,
              zip,
              state,
              country,
              countryCode,
              latitude,
              longitude,
            };
            setLocation(currentLocationData);
            setCurrentLocLoader(false);
            resolve(currentLocationData);
          } catch (err) {
            console.warn("Location fetch error:", err);
            setCurrentLocLoader(false);
            reject(err);
          }
        },
        async (error) => {
          console.warn("Geolocation error:", error);
          setCurrentLocLoader(false);
          if (error.code === error.PERMISSION_DENIED) {
            await Swal.fire({
              icon: "warning",
              title: "Location Access Denied",
              html: `You have denied location access.<br>Please allow it from browser settings or enter city manually.`,
              confirmButtonText: "OK",
            });
            setShowModal(true);
          }
        },
      );
    });
  };

  /* Function To Get State ------------------------------- */
  const getStates = async () => {
    const url = "getStates";
    const jsonData = {};
    try {
      authservice.postJsonData(url, jsonData).then((response) => {
        if (
          response.apiResponseCode === "1001" &&
          Array.isArray(response.stateDetail)
        ) {
          setStatesData(response.stateDetail);
        } else setStatesData([]);
      });
    } catch (error) {
      console.warn("States fetch error:", error);
      setStatesData([]);
    }
  };

  /* Function To Get Curent Location from IP ------------------------------- */
  const getIPLocation = async () => {
    try {
      const apiURL = "getIPInfo";
      const finalUrl = process.env.REACT_APP_API_URL + apiURL;
      const response = await axios.get(finalUrl);
      const { data } = response;
      const currentLocationData = {
        ip: data?.ip,
        city: data?.city,
        region: data?.region,
        zip: data?.zip,
        country: data?.country,
        countryCode: data?.countryCode,
        latitude: data?.latitude,
        longitude: data?.longitude,
        timezone: data?.timezone?.id || "",
        isp: data?.isp || "",
        org: data?.org || "",
        accuracy: data?.accuracy || "City Level (~10-50km)",
      };
      setLocation(currentLocationData);
      return currentLocationData;
    } catch (err) {
      console.error("Location fetch error:", err);
    }
  };

  const fetchStores = async (
    search = searchText,
    storeTypeId = null,
    pageNum,
  ) => {
    try {
      setLoader(true);
      const url = "getStores";
      const jsonData = {
        latitude: parseFloat(lat) || parseFloat(location?.latitude),
        longitude: parseFloat(lng) || parseFloat(location?.longitude),
        search,
        storeTypeID: storeTypeId,
        page: pageNum,
        pageLimit,
        sortByDistance:
          selectedSortOption?.label === "Sort By Distance" ? "ASC" : "",
        sortByEstimatedDuration:
          selectedSortOption?.label === "Sort By Delivery Time"
            ? selectedSortOption?.value
            : "",
      };
      const response = await authservice.postJsonData(url, jsonData);
      if (
        response?.apiResponseCode === "1001" &&
        Array.isArray(response?.data)
      ) {
        setLoader(false);
        setNearByStores((prev) =>
          pageNum === 1 ? response.data : [...prev, ...response.data],
        );
        setTotalRecords(response.totalRecords);
        setPageLimit(response?.pageLimit);
      } else {
        setLoader(false);
        setNearByStores([]);
        setTotalRecords();
      }
    } catch (error) {
      setLoader(false);
      console.warn("Store locations fetch error:", error);
      setNearByStores([]);
    }
  };

  const getCities = async () => {
    const url = "getCity";
    const jsonData = {};
    try {
      const response = await authservice.postJsonData(url, jsonData);
      if (
        response.apiResponseCode === "1001" &&
        Array.isArray(response.cityDetails)
      ) {
        const temp = response.cityDetails.map((city) => ({
          value: city.name,
          label: city.name,
          latitude: city.latitude,
          longitude: city.longitude,
        }));
        setCityOptions(temp);
        return temp;
      }
      setCityOptions([]);
      return [];
    } catch (error) {
      console.warn("City fetch error:", error);
      setCityOptions([]);
      return [];
    }
  };

  const getStoreTypes = async () => {
    const url = "storeTypes";
    const jsonData = {};
    try {
      authservice.postJsonData(url, jsonData).then((response) => {
        if (
          response.apiResponseCode === "1001" &&
          Array.isArray(response.data)
        ) {
          setStoreTypes(response.data);
        } else setStoreTypes([]);
      });
    } catch (error) {
      console.warn("Store Types fetch error:", error);
      setStoreTypes([]);
    }
  };

  useEffect(() => {
    getStates();
    getStoreTypes();
  }, []);

  useEffect(() => {
    const hasLatLng = lat && lng;
    const hasLocationCoords = location?.latitude && location?.longitude;
    const storeTypeIDDefined =
      selectedStore?.storeTypeID || selectedStore?.storeTypeID === null;

    if (hasLatLng || hasLocationCoords || storeTypeIDDefined) {
      const storeTypeID = storeTypeIDDefined
        ? selectedStore?.storeTypeID || null
        : null;

      fetchStores("", storeTypeID, pageNo, selectedSortOption);
    }
  }, [
    lat,
    location?.latitude,
    pageNo,
    selectedStore?.storeTypeID,
    selectedSortOption,
  ]);

  useEffect(() => {
    setPageNo(1);
  }, [selectedStore?.storeTypeID]);

  useEffect(() => {
    if (loadmoreIsClicked) {
      setLoader(false);
    }
  }, [loadmoreIsClicked, pageNo]);

  const contextValue = useMemo(
    () => ({
      location,
      setLocation,
      storeTypes,
      setStoreTypes,
      stores,
      setStores,
      sidebarIcons,
      nearbyStores,
      setNearByStores,
      cityOptions,
      selectedOption,
      setSelectedOption,
      totalRecords,
      pageLimit,
      pageNo,
      setPageNo,
      selectedStore,
      setSelectedStore,
      loader,
      setLoader,
      selectedSortOption,
      setSelectedSortOption,
      dropdownOpen,
      setDropdownOpen,
      storesLatLng,
      setStoresLatLng,
      hasSearched,
      setHasSearched,
      selectedStoreID,
      setSelectedStoreID,
      scrollToMapSectionRef,
      fetchCurrentLocation,
      fetchStores,
      getCities,
      showSelect,
      setShowSelect,
      currentLocLoader,
      setCurrentLocLoader,
      manuallyToggled,
      setManuallyToggled,
      getIPLocation,
      showModal,
      setShowModal,
      cityLatLng,
      setCityLatLng,
      recenterCurLoc,
      setRecenterCurLoc,
      searchText,
      setSearchText,
      statesData,
      setStatesData,
      loadmoreIsClicked,
      setLoadmoreIsClicked,
    }),
    [
      loadmoreIsClicked,
      searchText,
      storeTypes,
      stores,
      selectedOption,
      nearbyStores,
      selectedSortOption,
      loader,
      dropdownOpen,
      storesLatLng,
      hasSearched,
      showSelect,
      setShowSelect,
      currentLocLoader,
      setCurrentLocLoader,
      manuallyToggled,
      setManuallyToggled,
      showModal,
      setShowModal,
      cityLatLng,
      setCityLatLng,
      recenterCurLoc,
      statesData,
      setStatesData,
    ],
  );

  return (
    <StoreContext.Provider value={contextValue}>
      {children}
    </StoreContext.Provider>
  );
};

export default ApiContext;
